import { Component, ErrorInfo, ReactNode } from 'react';

// pdf.js can throw during render on older WebViews (missing platform APIs, worker failures).
// Without a boundary React unmounts the whole tree and the mini app goes blank, so the offer
// page and the material viewer each wrap their <Document> in this and keep the rest usable.
type Props = { children: ReactNode; fallback: ReactNode };
type State = { hasError: boolean };

class PdfErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('PDF render failed', error, info);
    }

    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
}

export default PdfErrorBoundary;
